module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hamv-dialog', {
    attrs: {
      "dialogProps": _vm.dialogProps,
      "showModal": _vm.showModal
    }
  }, [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "header",
      "data-qa": "Dialog-UploadFirmware-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('firmwareUploadDialogTitle')))]), _vm._v(" "), _c('el-form', {
    ref: "data",
    attrs: {
      "model": _vm.data,
      "id": "uploadform",
      "enctype": "multipart/form-data",
      "label-position": "left"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.uploadFirmware($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('version') ? _vm.$t('firmwareUploadInputVersionError') : '',
      "label": _vm.$t('firmwareUploadInputVersionLabel'),
      "label-width": _vm.labelWidth,
      "show-message": _vm.errors.has('version'),
      "data-qa": "Dialog-UploadFirmwareVersion-Item"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: _vm.validate.semver
        }
      }),
      expression: "{ rules: { required: true, regex: validate.semver} }"
    }],
    attrs: {
      "placeholder": _vm.$t('firmwareUploadInputVersionPlaceholder'),
      "clearable": "",
      "data-qa": "Dialog-UploadFirmwareVersion-Input",
      "name": "version",
      "required": "",
      "type": "text"
    },
    model: {
      value: (_vm.data.version),
      callback: function($$v) {
        _vm.$set(_vm.data, "version", $$v)
      },
      expression: "data.version"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('previous') ? _vm.$t('firmwareUploadInputPreviousError') : '',
      "label": _vm.$t('firmwareUploadInputPreviousLabel'),
      "label-width": _vm.labelWidth,
      "show-message": _vm.errors.has('previous'),
      "data-qa": "Dialog-UploadFirmwarePreVersion-Item"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: _vm.validate.semver
        }
      }),
      expression: "{ rules: { required: true, regex: validate.semver} }"
    }],
    attrs: {
      "placeholder": _vm.$t('firmwareUploadInputPreviousPlaceholder'),
      "clearable": "",
      "data-qa": "Dialog-UploadFirmwarePreVersion-Input",
      "name": "previous",
      "required": "",
      "type": "text"
    },
    model: {
      value: (_vm.data.lastVersion),
      callback: function($$v) {
        _vm.$set(_vm.data, "lastVersion", $$v)
      },
      expression: "data.lastVersion"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('sha1') ? _vm.$t('firmwareUploadInputSHA1Error') : '',
      "label": _vm.$t('firmwareUploadInputSHA1Label'),
      "label-width": _vm.labelWidth,
      "show-message": _vm.errors.has('sha1'),
      "data-qa": "Dialog-UploadFirmwareSHA1-Item"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: _vm.validate.sha1
        }
      }),
      expression: "{ rules: { required: true, regex: validate.sha1} }"
    }],
    attrs: {
      "placeholder": _vm.$t('firmwareUploadInputSHA1Label'),
      "clearable": "",
      "data-qa": "Dialog-UploadFirmwareSHA1-Input",
      "name": "sha1",
      "required": "",
      "type": "text"
    },
    model: {
      value: (_vm.data.sha1),
      callback: function($$v) {
        _vm.$set(_vm.data, "sha1", $$v)
      },
      expression: "data.sha1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('model') ? _vm.$t('firmwareUploadInputModelError') : '',
      "label": _vm.$t('firmwareUploadInputModelLabel'),
      "label-width": _vm.labelWidth,
      "show-message": _vm.errors.has('model'),
      "data-qa": "Dialog-UploadFirmwareModel-Item"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    attrs: {
      "placeholder": _vm.$t('firmwareUploadInputModelLabel'),
      "clearable": "",
      "data-qa": "Dialog-UploadFirmwareModel-Input",
      "name": "model",
      "required": "",
      "type": "text"
    },
    model: {
      value: (_vm.data.model),
      callback: function($$v) {
        _vm.$set(_vm.data, "model", $$v)
      },
      expression: "data.model"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('firmwareUploadInputTriggerLabel'),
      "label-width": _vm.labelWidth,
      "show-message": _vm.errors.has('trigger'),
      "data-qa": "Dialog-UploadFirmwareTrigger-Item"
    }
  }, [_c('el-switch', {
    attrs: {
      "placeholder": _vm.$t('firmwareUploadInputTriggerLabel'),
      "clearable": "",
      "data-qa": "Dialog-UploadFirmwareTrigger-Input",
      "name": "trigger"
    },
    model: {
      value: (_vm.data.trigger),
      callback: function($$v) {
        _vm.$set(_vm.data, "trigger", $$v)
      },
      expression: "data.trigger"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('firmwareUploadInputImageLabel'),
      "label-width": _vm.labelWidth,
      "data-qa": "Dialog-UploadFirmwareImage-Item"
    }
  }, [_c('div', {
    staticClass: "upload-block"
  }, [_c('input', _vm._b({
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|size:4096'),
      expression: "'required|size:4096'"
    }],
    staticClass: "input-file",
    attrs: {
      "id": _vm.uploadFieldName,
      "name": _vm.uploadFieldName,
      "data-qa": "Dialog-UploadFirmwareImage-UploadField",
      "required": "",
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.name, $event.target.files)
      }
    }
  }, 'input', _vm.data.imgFile, false)), _vm._v(" "), _c('label', {
    staticClass: "el-button el-button--default",
    attrs: {
      "for": _vm.uploadFieldName
    }
  }, [_vm._v(_vm._s(_vm.$t('firmwareUploadInputUploadFieldNameLabel')))]), _vm._v(" "), _c('div', {
    staticClass: "selected-file-name"
  }, [_vm._v(_vm._s(_vm.getFileName))])]), _vm._v(" "), (_vm.errors.has(_vm.uploadFieldName)) ? _c('div', {
    staticClass: "help is-danger"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('firmwareUploadTipImage')) + "\n      ")]) : _vm._e()])], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('el-button', {
    staticClass: "btn-close",
    attrs: {
      "data-qa": "Dialog-UploadFirmware-Button-Close",
      "type": "text"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('firmwareUploadDialogButtonCloseText')) + "\n    ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.loading || _vm.errors.any(),
      "loading": _vm.loading,
      "data-qa": "Dialog-UploadFirmware-Button-Upload",
      "type": "warning"
    },
    on: {
      "click": _vm.uploadFirmware
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('firmwareUploadDialogButtonUploadText')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40e4118a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FirmwareUpload/FirmwareUpload.vue
// module id = 964
// module chunks = 3